console.log('Webpack builded');



// WEBPACK FOOTER //
// ./src/js/main.js